var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8C13 8.27614 12.7761 8.5 12.5 8.5L4.70711 8.5L7.85355 11.6464C8.04882 11.8417 8.04882 12.1583 7.85355 12.3536C7.65829 12.5488 7.34171 12.5488 7.14645 12.3536L3.14645 8.35355C2.95118 8.15829 2.95118 7.84171 3.14645 7.64645L7.14645 3.64645C7.34171 3.45118 7.65829 3.45118 7.85355 3.64645C8.04882 3.84171 8.04882 4.15829 7.85355 4.35355L4.70711 7.5L12.5 7.5C12.7761 7.5 13 7.72386 13 8Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.5df549fc0bab8807612759e53ea911f8.svg";
export { ForwardRef as ReactComponent };